import type {
  Cmd,
  ImmutableProgram,
  ImmutableResult,
  InitialProperties,
} from '@gl/lit/components/mixins/immutable_component/index.js';
import {
  Variant,
  makeVariants,
} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {VariantsFor} from '@gl/lit/types/architecture.js';
import type FlyDropdownV2 from './index.js';

export type Model = {
  open: boolean;
  disabled: boolean;
  hasActionButton: boolean;
};

export const Msg = makeVariants({
  open: Variant<void>()('open'),
  close: Variant<void>()('close'),
  enable: Variant<void>()('enable'),
  disable: Variant<void>()('disable'),
  registerActionButton: Variant<void>()('register-action-button'),
  removeActionButton: Variant<void>()('remove-action-button'),
});

export type Msg = VariantsFor<typeof Msg>;

// -- Init

function init(props: InitialProperties): ImmutableResult<Model> {
  return {
    open: <boolean>props.get('open') ?? false,
    disabled: <boolean>props.get('disabled') ?? false,
    hasActionButton: false,
  } as const;
}

// -- Update

function update(msg: Msg, model: Model, cmd: Cmd): ImmutableResult<Model> {
  switch (msg.tag) {
    case 'open':
      return [
        {...model, open: true},
        cmd((host: FlyDropdownV2) => {
          host.onOpen();
        }),
      ] as const;
    case 'close':
      return [
        {...model, open: false},
        cmd((host: FlyDropdownV2) => {
          host.onClose();
        }),
      ] as const;
    case 'enable':
      return {...model, disabled: false} as const;
    case 'disable':
      return {...model, disabled: true} as const;
    case 'register-action-button':
      return {...model, hasActionButton: true} as const;
    case 'remove-action-button':
      return {...model, hasActionButton: false} as const;
  }
}

// -- Program

export var main: ImmutableProgram<Model, Msg> = {
  init,
  update,
};
